import PropTypes from 'prop-types';

export const bookClubProps = {
  id: PropTypes.string.isRequired,
  currentPickAudiobookId: PropTypes.string,
  displayName: PropTypes.string.isRequired,
  extendedDescription: PropTypes.string.isRequired,
  followedByCurrentUser: PropTypes.bool.isRequired,
  featuredImageCloudinaryImageId: PropTypes.string.isRequired,
  hostName: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
};

export const bookClub = PropTypes.shape(bookClubProps);
